import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4f6f7608"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "inventory-subtable-link" };
const _hoisted_2 = ["href"];
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", {
    class: "pi pi-external-link",
    style: { "margin-left": "10px" }
}, null, -1));
const _hoisted_4 = [
    _hoisted_3
];
import { computed } from "vue";
import OneDeskCountryFlag from "@/components/atoms/OneDeskCountryFlag.vue";
import ImageWithNoImageDefault from "@/components/atoms/ImageWithNoImageDefault.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WebSiteLink',
    props: {
        displayedWebsiteUrl: {},
        hrefUrl: {},
        iconType: {},
        iconData: {}
    },
    setup(__props) {
        const { displayedWebsiteUrl = "", iconType = null, iconData = null } = __props;
        const displayMarketFlag = computed(() => {
            return iconType == "market";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (displayMarketFlag.value)
                    ? (_openBlock(), _createBlock(OneDeskCountryFlag, {
                        key: 0,
                        class: "market-flag",
                        "market-code": _ctx.iconData
                    }, null, 8, ["market-code"]))
                    : (_openBlock(), _createBlock(ImageWithNoImageDefault, {
                        key: 1,
                        source: _ctx.iconData
                    }, null, 8, ["source"])),
                _createElementVNode("span", null, _toDisplayString(_ctx.displayedWebsiteUrl), 1),
                (_ctx.hrefUrl)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 2,
                        href: _ctx.hrefUrl
                    }, _hoisted_4, 8, _hoisted_2))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
